export enum RoomTypeID {
  Basic = 'basic_room',
  Combat = 'combat_room',
  Treasure = 'treasure_room',
  Boss = 'boss_room',
  Safe = 'safe_room',
  Ambush = 'ambush_room',
  Puzzle = 'puzzle_room',
  Workshop = 'workshop_room',
  Entrance = 'entrance_room',
  Exit = 'exit_room',
  Shop = 'shop_room',
  Library = 'library_room',
  Armory = 'armory_room',
  Kitchen = 'kitchen_room',
  Bedroom = 'bedroom_room',
  Garden = 'garden_room',
  Shrine = 'shrine_room',
  Gallery = 'gallery_room',
  Storage = 'storage_room',
  SummoningRoom = 'summoning_room',
  IceChamber = 'ice_chamber',
  ChasmRoom = 'chasm_room',
  SmallShrine = 'small_shrine',
  MerchantShop = 'merchant_shop',
  TreasureVault = 'treasure_vault',
  BossArena = 'boss_arena',
  KrampusLair = 'krampus_lair',
  WarmthSanctuary = 'warmth_sanctuary',
  Hearth = 'hearth_room',
}
